<template>
  <v-container class="fill-height">
    <v-row align="center" justify="center">
      <v-col cols="12" sm="8" md="6" lg="4">

        <!-- LOGIN -->
        <v-card v-if="step === 'login'">

          <v-toolbar color="primary" dark>
            <v-toolbar-title>
              Вход для супер-администратора
            </v-toolbar-title>
          </v-toolbar>

          <v-card-text>

            <v-form @submit.prevent="login">

              <v-text-field
                v-model="loginForm.email"
                label="Email"
              />

              <v-text-field
                v-model="loginForm.parol"
                label="Пароль"
                type="password"
              />

              <v-btn
                block
                color="primary"
                type="submit"
                :loading="loading"
              >
                Авторизоваться
              </v-btn>

            </v-form>

          </v-card-text>

          <v-divider />

          <v-card-actions>
            <v-spacer />
              <v-btn text color="primary" @click="step = 'register'">
                Заявка на регистрацию
              </v-btn>
            <v-spacer />
          </v-card-actions>

        </v-card>

        <!-- REGISTER -->
        <v-card v-else-if="step === 'register'">

          <v-toolbar color="primary" dark>
            <v-toolbar-title>
              Регистрация супер-администратора
            </v-toolbar-title>
          </v-toolbar>

          <v-card-text>

            <v-form ref="registerFormRef" @submit.prevent="register">

              <v-text-field
                v-model="registerForm.name"
                label="Имя"
              />

              <v-text-field
                v-model="registerForm.email"
                label="Email"
                :rules="[rules.required, rules.email]"
              />

              <v-text-field
                v-model="registerForm.password"
                label="Пароль"
                type="password"
                :rules="[
                  rules.required,
                  rules.password,
                  rules.passwordLetter,
                  rules.passwordNumber,
                  rules.passwordSymbol
                ]"
              />

              <v-text-field
                v-model="registerForm.password_confirmation"
                label="Подтвердить пароль"
                type="password"
                :rules="[rules.required]"
              />

              <v-btn
                block
                color="primary"
                type="submit"
                :loading="loading"
              >
                Отправить заявку
              </v-btn>

            </v-form>

          </v-card-text>

          <v-divider />

          <v-card-actions>
            <v-spacer />
              <v-btn text @click="step = 'login'">
                Назад к входу
              </v-btn>
            <v-spacer />
          </v-card-actions>

        </v-card>

        <!-- SETUP 2FA -->
        <v-card v-else-if="step === 'setup'">

          <v-card-text class="text-center">

            <h3>Настройка 2FA</h3>

            <img :src="qrUrl" width="200" />

            <v-form @submit.prevent="confirm2FA">

              <v-text-field
                v-model="code"
                label="Код"
              />

              <v-btn
                color="primary"
                type="submit"
              >
                Подтвердить
              </v-btn>

            </v-form>

          </v-card-text>

        </v-card>

        <!-- VERIFY -->
        <v-card v-else-if="step === 'verify'">

          <v-card-text>

            <h3>2FA верификация</h3>

            <v-form @submit.prevent="verify">

              <v-text-field
                v-model="code"
                label="Код"
              />

              <!-- Enter косылды -->
              <v-btn
                color="primary"
                type="submit"
              >
                Подтвердить
              </v-btn>

            </v-form>

          </v-card-text>

        </v-card>

        <!-- REQUEST SENT -->
        <v-card v-else-if="step === 'request_sent'">

          <v-card-text class="text-center py-10">

            <v-icon
              size="70"
              color="success"
            >
              mdi-check-circle
            </v-icon>

            <h2 class="mt-4">
              Отправлено!
            </h2>

            <p class="mt-2">
              Ждите подтверждения от главного администратора.
            </p>

            <v-btn
              class="mt-5"
              color="primary"
              @click="step = 'login'"
            >
              Назад к входу
            </v-btn>

          </v-card-text>

        </v-card>

      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {

  props: {
    language: {
      type: String,
      default: 'ru'
    }
  },

  data() {
    return {

      step: 'login',

      loading: false,

      loginForm: {
        email: '',
        parol: ''
      },

      registerForm: {
        name: '',
        email: '',
        password: '',
        password_confirmation: ''
      },

      adminId: null,
      sessionToken: null,

      qrUrl: null,
      code: '',

      rules: {
        required: v => !!v || 'Обязательное поле',

        email: v =>
          /.+@.+\..+/.test(v) || 'Некорректный email',

        password: v =>
          (v && v.length >= 8) || 'Пароль минимум 8 символов',

        passwordLetter: v =>
          /[A-Za-z]/.test(v) || 'Пароль должен содержать хотя бы одну букву',

        passwordNumber: v =>
          /\d/.test(v) || 'Пароль должен содержать хотя бы одну цифру',

        passwordSymbol: v =>
          /[!@#$%^&*(),.?":{}|<>_\-\\[\]\\/]/.test(v)
          || 'Пароль должен содержать хотя бы один спецсимвол'
      }
    };
  },

  methods: {

    // LOGIN
    async login() {

      try {

        this.loading = true;

        const res = await this.$http.post(
          `/ru/superadmin/auth`,
          this.loginForm
        );

        if (res.data.requires_2fa_setup) {

          this.adminId = res.data.admin_id;

          await this.loadSetup();

          this.step = 'setup';
        }

        else if (res.data.requires_2fa) {

          this.sessionToken = res.data.session_token;

          this.step = 'verify';
        }

        else {

          this.finish(res.data);
        }

      } catch (e) {

        console.error(e);

        alert(
          e?.response?.data?.message ||
          'Login error'
        );

      } finally {

        this.loading = false;
      }
    },

    // REGISTER REQUEST
    async register() {
      const valid = this.$refs.registerFormRef.validate();

      if (!valid) return;

      if (this.registerForm.password !== this.registerForm.password_confirmation) {
        alert('Пароли не совпадают');
        return;
      }
      try {

        this.loading = true;

        await this.$http.post(
          `/ru/superadmin/register`,
          this.registerForm
        );

        this.registerForm = {
          name: '',
          email: '',
          password: '',
          password_confirmation: ''
        };

        this.step = 'request_sent';

      } catch (e) {

        console.error(e);

        alert(
          e?.response?.data?.message ||
          'Registration error'
        );

      } finally {

        this.loading = false;
      }
    },

    // LOAD QR
    async loadSetup() {

      const res = await this.$http.post(
        `/ru/superadmin/2fa/setup`,
        {
          admin_id: this.adminId
        }
      );

      this.qrUrl = res.data.qr_url;
    },

    // CONFIRM 2FA
    async confirm2FA() {

      await this.$http.post(
        `/ru/superadmin/2fa/confirm`,
        {
          admin_id: this.adminId,
          code: this.code
        }
      );

      this.step = 'login';
    },

    // VERIFY LOGIN
    async verify() {

      const res = await this.$http.post(
        `/ru/superadmin/auth/2fa`,
        {
          session_token: this.sessionToken,
          code: this.code
        }
      );

      this.finish(res.data);
    },

    // FINAL LOGIN
    finish(data) {

      localStorage.setItem(
        'token',
        data.token
      );

      this.$emit('login', {
        token: data.token,
        user: data.admin
      });
    }
  }
};
</script>
